import AceEditor from 'react-ace';
import Beautify from 'ace-builds/src-noconflict/ext-beautify';
import useMounted from 'hooks/useMounted';
import { useRef, useState } from 'react';
import useUpdated from 'hooks/useUpdated';

const Answer = ({ data, onResponse }) => {
  const [show, setShow] = useState(false);
  const ref = useRef(null);

  useMounted(() => {
    if (ref && ref.current) {
      Beautify.beautify(ref.current.editor.session);
    }
  });

  useUpdated(() => {
    setShow(false);
  }, [data]);

  return (
    <>
      {show ?
        <>
          <div className="Description">
            {data.description}
          </div>
          {data.example &&
            <div className="Example">
              <div className="Title">Example</div>
              <div className="ExampleEditor">
                <AceEditor
                  ref={ref}
                  width="100%"
                  height="300px"
                  mode={data.lang || 'javascript'}
                  theme="monokai"
                  name="Editor"
                  showGutter={false}
                  showPrintMargin={false}
                  defaultValue={data.example}
                  commands={Beautify.commands}
                  tabSize={2}
                  readOnly
                />
              </div>
            </div>
          }
          <div style={{ paddingTop: 40, textAlign: 'center' }}>
            <button className="Incorrect" onClick={() => onResponse(false)}>
              Incorrect
            </button>
            <button className="Correct" onClick={() => onResponse(true)}>
              Correct
            </button>
          </div>
        </>
        :
        <div style={{ textAlign: 'center' }}>
          <button className="ShowAnswer" onClick={() => setShow(true)}>Show Answer</button>
        </div>
      }
    </>
  )
};

export default Answer;